
const Header = () => {

    return (
        <div className="header">
            <div>
                <span className="logo ">KeepSafe  </span>

                <b>My photo album </b>

            </div>
             <p>
             Unlimited space for photos on Keepsafe <br />
             Your photos are safe here .
          
            </p> 

        </div>

    ) ; 

}


export default Header ;  

